import {
  GET_SIDEBAR_CONFIGURATION,
  GET_SIDEBAR_CONFIGURATION_SUCCESS,
  GET_SIDEBAR_CONFIGURATION_ERROR,
  GET_SIDEBAR_CONFIGURATION_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSidebarConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case GET_SIDEBAR_CONFIGURATION:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SIDEBAR_CONFIGURATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SIDEBAR_CONFIGURATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SIDEBAR_CONFIGURATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSidebarConfiguration;
